import { inject } from "@angular/core";
import { Router, CanActivateFn, CanActivateChildFn } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { of } from "rxjs";
import { JwtAuthService } from "../jwt-auth.service";

export const SalesExecutiveAccessGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
{
    const router: Router = inject(Router);
    const snack: MatSnackBar = inject(MatSnackBar);
    const jwtAuth: JwtAuthService = inject(JwtAuthService);

    var accessDenied = () => 
        snack.open("You do not have access to this page!", "OK", {
        duration: 4000,
    });

    // If user is Sales Executive, check if they're trying to access restricted areas
    if(jwtAuth.isSalesExecutive()) {
        const restrictedPaths = [
            '/settings',
            '/admin/apps/help-center',
            '/crm/contacts',
            '/crm/emails', 
            '/crm/reporting',
            '/project-management/dashboard'
        ];

        // Check if current route is restricted
        for (const restrictedPath of restrictedPaths) {
            if (state.url.startsWith(restrictedPath)) {
                accessDenied();
                const urlTree = router.parseUrl('/dashboard');
                return of(urlTree);
            }
        }
    }

    // Allow the access
    return of(true);
}; 